import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getrolesaction, getaccountsaction  } from "../../actions/getRolesActions"
import { getadmintenants  } from "../../actions/userActions"
import intl from 'react-intl-universal';
import Box from '@mui/material/Box';
import AdminUserList from './AdminUserList'

class AdminDash extends Component {



    componentDidMount() {
        this.props.getrolesaction(this.props.apitoken);
        this.props.getaccountsaction(this.props.apitoken);
        this.props.getadmintenants(this.props.apitoken);
      }

    render () {  
        return (
       <Box  sx={{ p: 2, border: '1px dashed grey' }}>
          <h1>{intl.get('USERMANAGEMENT')}</h1>
          <p>{intl.get('DASH_USERMANAGEMENT_DESC')}</p> 
          <hr /> 
              <AdminUserList apitoken={this.props.apitoken}/>
        </Box>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken
  });


  const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getrolesaction: getrolesaction,
        getaccountsaction: getaccountsaction,
        getadmintenants: getadmintenants
        }, dispatch);
    }


export default connect(mapStateToProps,mapDispatchToProps)(AdminDash);
